<div class="container" *ngIf="appService.theme$ | async as theme">
          <div class="main-container-about">
               <app-about-section class="section" *ngIf="generalDataGroups" [dataGroups]="generalDataGroups"></app-about-section>
               <app-about-section class="section" *ngIf="faqDataGroups" [dataGroups]="faqDataGroups"></app-about-section>
               <app-about-section class="section" *ngIf="legalDataGroups" [dataGroups]="legalDataGroups"></app-about-section>
               <div class="container-logo">
                    @if (theme === 'light') {
                    <img style="width: 25%; height:50%" src="../../../assets/apaLogo/APA_logo_light.svg" alt="APA_Logo" />
                    } @else {
                    <img style="width: 25%; height: 50%" src="../../../assets/apaLogo/APA_logo_dark.svg" alt="APA_Logo" />
                    }
                    <div class="accordian-item-content-text">Logbook Version {{ version }}</div>
               </div>
          </div>
</div>